import { render, staticRenderFns } from "./TagUser.vue?vue&type=template&id=2ee3eaf6&scoped=true"
import script from "./TagUser.vue?vue&type=script&lang=js"
export * from "./TagUser.vue?vue&type=script&lang=js"
import style0 from "./TagUser.vue?vue&type=style&index=0&id=2ee3eaf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3eaf6",
  null
  
)

export default component.exports